function tracingEnabled() {
    return window['_sc_tracing'] === true || !!document.querySelector('.sc-tracing-on');
}

export function setupTracing(){
    window['_sc_whoami'] = whoami;

    let _sc_query = window.location.search;
    let _sc_href = window.location.href;
    window['_sc_query'] = _sc_query;
    window['_sc_href'] = _sc_href;

    function setPageUserData() {
        var u = JSON.parse(this.responseText);
        var ev = new CustomEvent('userdata', {detail: {
                userData: u
            }});
        window['_sc_user_data'] = u;
        window.dispatchEvent(ev);
    }

    whoami("pv", {}, setPageUserData);

    document.addEventListener("DOMContentLoaded", function () {
        if (!tracingEnabled()) return;
        tagCheckoutElements();
        setupPageMetrics();
        watchForCheckoutElements();
    });
}

function watchForCheckoutElements(){
    const rescan = () => {
        tagCheckoutElements();
        setupPageMetrics();
    };
    const obs = new MutationObserver((mutations) => {
        for (const m of mutations) {
            if (m.addedNodes && m.addedNodes.length) {
                rescan();
                return;
            }
        }
    });
    obs.observe(document.body, {childList: true, subtree: true});
    if (window.jQuery) {
        window.jQuery(document.body).on('updated_checkout payment_method_selected', rescan);
    }
}

const SC_VISITOR_STORAGE_KEY = 'sc_visitor_id';
const UUID_V4_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function _newClientVisitorId() {
    const cryptoApi = typeof globalThis !== 'undefined' ? globalThis.crypto : null;
    if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
        return cryptoApi.randomUUID();
    }

    // Older browsers still need a stable identifier when randomUUID is absent.
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function _clientVisitorId() {
    const browserWindow = typeof window !== 'undefined' ? window : null;
    let storage = null;

    try {
        storage = browserWindow && browserWindow.localStorage;
        const stored = storage && storage.getItem(SC_VISITOR_STORAGE_KEY);
        if (stored && UUID_V4_PATTERN.test(stored)) {
            return stored.toLowerCase();
        }
    } catch (e) {
        // Private browsing and restrictive storage policies are valid fallbacks.
    }

    const id = _newClientVisitorId().toLowerCase();
    try {
        if (storage) storage.setItem(SC_VISITOR_STORAGE_KEY, id);
    } catch (e) {
        // The in-memory module value still joins requests on this page.
    }
    return id;
}

// This is sent on every request so PV and interactions can be joined even
// before the server's Set-Cookie response is visible to the browser.
const _clientVisitor = _clientVisitorId();

// Queue every whoami() call placed before the first `pv` response lands —
// the stable client ID keeps the PV and any queued `pi` interaction linked
// while the server's Set-Cookie response is still in flight. Once PV resolves
// (or pagehide fires, whichever comes first), the queue is flushed.
let _pvDone = false;
const _pendingWhoami = [];

function _sendWhoami(ev, data, reqListener) {
    const headers = {
        "x-ev": ev,
        "x-referer": window['_sc_href'],
        "x-page-referer": document.referrer,
        "x-query": window['_sc_query'],
        "x-iw": "" + window.innerWidth,
        "x-sc-visitor": _clientVisitor,
        "Content-Type": "application/json;charset=UTF-8",
    };
    if (tracingEnabled()) {
        headers["x-trace"] = "1";
    }
    const req = fetch("/frontend/whoami", {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
        keepalive: true,
        credentials: "same-origin",
    });
    if (reqListener) {
        req.then(r => r.text()).then(text => reqListener.call({responseText: text}));
    }
    return req;
}

function _flushWhoamiQueue() {
    if (!_pendingWhoami.length) return;
    const batch = _pendingWhoami.splice(0, _pendingWhoami.length);
    for (const item of batch) {
        _sendWhoami(item.ev, item.data, item.reqListener);
    }
}

// Last-resort flush: if the user navigates away before PV resolves, send
// whatever's queued so they reach the server before the page tears down. The
// client ID above keeps those events attributable to the same pageview.
window.addEventListener('pagehide', function () {
    if (!_pvDone) _flushWhoamiQueue();
}, true);

export function whoami(ev, data={}, reqListener){
    if (ev === 'pv') {
        const req = _sendWhoami(ev, data, reqListener);
        // Drain the queue once the server has had a chance to Set-Cookie.
        // We don't care whether PV resolved with a 2xx — even a 500 means
        // it landed and any cookie response was applied (or not, in which
        // case we're no worse off than the current behaviour).
        const onDone = function () {
            _pvDone = true;
            _flushWhoamiQueue();
        };
        req.then(onDone, onDone);
        return;
    }
    if (!_pvDone) {
        _pendingWhoami.push({ev, data, reqListener});
        return;
    }
    _sendWhoami(ev, data, reqListener);
}


function tagCheckoutElements(){
    document.querySelectorAll('li.wc_payment_method').forEach(function(li){
        const id = (li.className.match(/payment_method_(\S+)/) || [])[1];
        if (!id) return;
        const label = li.querySelector('label');
        if (label && !label.dataset.whoamiId) {
            label.dataset.whoamiId = 'pay-' + id;
            label.dataset.whoami = 'first-hover,click';
        }
        const radio = li.querySelector('input[type=radio]');
        if (radio && !radio.dataset.whoamiId) {
            radio.dataset.whoamiId = 'pay-radio-' + id;
            radio.dataset.whoami = 'click';
        }
    });
    const placeOrder = document.querySelector('#place_order');
    if (placeOrder && !placeOrder.dataset.whoamiId) {
        placeOrder.dataset.whoamiId = 'place-order';
        placeOrder.dataset.whoami = 'first-hover,click';
    }
    // sc-checkout-trust experiment uses custom button IDs instead of standard WC payment radios
    const customButtons = {
        'goto-stripe': 'pay-stripe',
        'goto-pp': 'pay-paypal',
    };
    for (const [id, traceId] of Object.entries(customButtons)) {
        const el = document.getElementById(id);
        if (el && !el.dataset.whoamiId) {
            el.dataset.whoamiId = traceId;
            el.dataset.whoami = 'first-hover,click';
        }
    }
}

function setupPageMetrics(){
    const onScrollToEl = window['onScrollToEl'];

    const tracedElements = document.querySelectorAll('[data-whoami]:not([data-whoami-wired])');
    tracedElements.forEach(function(element) {
        const traceSpec = element.dataset.whoami;
        const traceId = element.dataset.whoamiId;
        if(!traceId){
            return;
        }
        element.dataset.whoamiWired = '1';
        const traces = traceSpec.split(",");
        for(let tr of traces){
            tr = tr.trim();
            switch (tr) {
                case "first-scroll":
                    onScrollToEl(element, function(){
                        whoami('pi', {action: 'first-scroll',  element: traceId} )
                    });
                    break;
                case "first-hover":
                    element.addEventListener("mouseover", function(event) {
                        whoami('pi', {action: 'first-hover',  element: traceId} )
                    }, {once: true});
                    break;
                case "click":
                    element.addEventListener("click", function(event) {
                        whoami('pi', {action: 'click',  element: traceId} )
                    });
                    break;
            }
        }
    });
}
